import { status } from 'skin/event/status';
import table from './table';

const defTar = (obj, ms, story, data, d, action) => {
	console.log('[Тариф  - Мастер] событие', obj);
	switch (obj.type) {
		case 'table':
			return table(obj, d, action, ms, story, data);
		default:
			return status.action;
	}
};

export default defTar;
